import { AxiosResponse } from 'axios';
import httpClient from './httpClient';
import API from '../constants/api';
import { IsLoggedInUser } from '../../../../common/model/IUser';

const customerApi = {
  isLoggedIn(): Promise<AxiosResponse<IsLoggedInUser>> {
    return httpClient.get<IsLoggedInUser>(API.IS_LOGGED_IN).then((response: AxiosResponse<IsLoggedInUser>) => response);
  },
};

export default customerApi;
